module.exports = "/365FarmNet/dist/userSettings.a26ade2f7414249cf3b29242e8ff512c.html";